
import { createTheme } from '@mui/material/styles';
import palette from './theme/palette';
import shadows from './theme/shadows';
import typography from './theme/typography';
import customShadows from './theme/customShadows';
import componentsOverride from './theme/overrides';
import { frFR as dataGridFR } from '@mui/x-data-grid/locales';

export default function createAppTheme(direction = 'ltr') {
  // 1️⃣ Options de base
  const themeOptions = {
    palette,
    typography,
    shape: { borderRadius: 6 },
    shadows: shadows(),
    customShadows: customShadows(),
    direction,
    components: {}, // on peut mettre les overrides ici plus tard

  };

  // 2️⃣ Crée le thème de base
  let theme = createTheme(themeOptions,dataGridFR);
 return theme;
  // 3️⃣ Étend avec overrides
  theme = createTheme(theme, {
    components: componentsOverride(theme),
  });

 
}